import { useCallback } from "react"
import { useGetData, usePostData } from "services/sales"
import { handleResponse } from "utils/fetch"

export const initSubsidyCounty = 2 // 台北市
export const initLocalSubsidyType = 2303 // 台北市新購 FIXME: 之後要調整不能寫死

export const DEFAULT_SUBSIDY_UNIT_FOR_PERSON = 1
export const DEFAULT_SUBSIDY_UNIT_FOR_CORPORATION = 2

export const SUBSIDY_TYPE_NONE = 0
export const SUBSIDY_TYPE_APPLY = 1
export const SUBSIDY_TYPE_TES_ONLY = 1
export const SUBSIDY_TYPE_TES_AND_LOCAL = 2
export const SUBSIDY_TYPE_LOCAL_ONLY = 9

export const DEFAULT_PLATE_TYPE = 1

export const subsidies = [
  {
    title: "不申請補助",
    type: SUBSIDY_TYPE_NONE,
    value: {
      IsTES: false,
      IsEPA: false,
      IsEPB: false,
    },
  },
  {
    title: "僅申請產業發展署補助",
    type: SUBSIDY_TYPE_TES_ONLY,
    value: {
      IsTES: true,
      IsEPA: false,
      IsEPB: false,
    },
  },
  {
    title: "僅申請環境部補助",
    type: SUBSIDY_TYPE_LOCAL_ONLY,
    value: {
      IsTES: false,
      IsEPA: true,
      IsEPB: false,
    },
  },
  {
    title: "僅申請各縣市環保局補助",
    type: SUBSIDY_TYPE_LOCAL_ONLY,
    value: {
      IsTES: false,
      IsEPA: false,
      IsEPB: true,
    },
  },
  {
    title: "僅申請產業發展署與環境部補助",
    type: SUBSIDY_TYPE_TES_AND_LOCAL,
    value: {
      IsTES: true,
      IsEPA: true,
      IsEPB: false,
    },
  },
  {
    title: "僅申請產業發展署與各縣市環保局補助",
    type: SUBSIDY_TYPE_TES_AND_LOCAL,
    value: {
      IsTES: true,
      IsEPA: false,
      IsEPB: true,
    },
  },
  {
    title: "僅申請環境部及各縣市環保局補助",
    type: SUBSIDY_TYPE_LOCAL_ONLY,
    value: {
      IsTES: false,
      IsEPA: true,
      IsEPB: true,
    },
  },
  {
    title: "申請產業發展署與環境部及各縣市環保局補助",
    type: SUBSIDY_TYPE_TES_AND_LOCAL,
    value: {
      IsTES: true,
      IsEPA: true,
      IsEPB: true,
    },
  },
]

export const useSubsidy = () => {
  const fetchData = useGetData("/tw/api/subsidy/get-subsidy-type")
  const queryData = usePostData("/tw/api/subsidy/get-subsidy-detail")

  const fetchSubsidyOptions = useCallback(() => {
    return fetchData()
      .then(handleResponse)
      .then((response) => response.Data)
  }, [fetchData])

  const querySubsidyDetail = useCallback(
    (payload) => {
      return queryData(payload)
        .then(handleResponse)
        .then((response) => response.Data)
    },
    [queryData],
  )

  return { fetchSubsidyOptions, querySubsidyDetail }
}
